#import "@/components/common/LinkFragment.gql"

fragment ContentRecommendationSlideFragment on contentRecommendationSlide_Entry {
  id
  typeHandle
  heading
  backgroundColorGray
  recommendations: articleBlocksRecommendations {
    ... on articleBlocksRecommendationsBlock_Entry {
      id
      tag
      image {
        url
        title
      }
      underliner
      linkit {
        ...LinkFragment
      }
    }
  }
}
